export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14314.1eefe05e.jpg";